import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { DrawerBody, DrawerHeader, IconButton, Subhead, cn } from '@growtherapy/sprout-ui';

export function ReflectionTopicsDrawer({
  title,
  content,
  onClickBackButton,
  isDarkTheme = false,
}: {
  title: string;
  content: React.ReactNode;
  onClickBackButton?: () => void;
  /** Supplied by `ReflectionTopicsDrawerWrapper`, which reads the theme context. */
  isDarkTheme?: boolean;
}) {
  const t = useTranslate();

  return (
    <>
      <DrawerHeader>
        <div className='flex items-center rebrand:h-component-125'>
          {onClickBackButton && (
            <IconButton
              onClick={onClickBackButton}
              className='mr-4 w-8 h-8 flex justify-center items-center'
              iconSize='xs'
              aria-label={t('telehealth-core:core.goBack')}
              data-testid='reflection-topics.button.back'
              iconDefinition={faArrowLeft}
            />
          )}
          <Subhead.Small
            as='h3'
            className={cn({
              'rebrand:text-text-inverse': isDarkTheme,
            })}
          >
            {title}
          </Subhead.Small>
        </div>
      </DrawerHeader>
      <DrawerBody>{content}</DrawerBody>
    </>
  );
}
